class RecoverFileMountService {
    constructor($timeout, $q, $filter, crudService, sseService, sharedPersistenceService, utilsService, notificationService, storageService) {
        this.$timeout = $timeout;
        this.$q = $q;
        this.$filter = $filter;
        this.fileTypesFilter = $filter('fileTypes');
        this.dateFilter = $filter('localizeDate');
        this._crudService = crudService;
        this._sseService = sseService;
        this._sharedPersistenceService = sharedPersistenceService;
        this._utilsService = utilsService;
        this._storageService = storageService;
        this._notificationService = notificationService;
        this.TASKS_REST = this._sharedPersistenceService.getRestEndpoints().TASKS_REST;
        this.TARGETS_REST = this._sharedPersistenceService.getRestEndpoints().TARGET_ENDPOINT;
        this.rejectStates = ['TERMINATING', 'ERROR', 'FATAL'];
        this.isWindowsOs = false;
    }

    getPageNumber() {
        this.pageSize = 1000;
    }

    getSubscriptionsId() {
        return this._storageService.getSubscription().uuid;
    }

    getTargets() {
        return this._crudService.get(this.TARGETS_REST).then(res => {
            return res.data.items;
        });
    }

    restore(restoreData, taskId) {
        return this._crudService.post(`tasks/${taskId}/flr/doflr`, restoreData);
    }


    testDiscovery(vmUuid, snapUuid) {
        return this._crudService.post(`virtualMachine/${vmUuid}/flr/${snapUuid}`).then(res => {
            return res.data.entities;
        });
    }

    fetchFolder(folder, snapUuid, selectedDisks) {

        const browseEndPoint = `restore/flr/${snapUuid}`;
        const startsWithSlash = folder ? folder.fullItemName.indexOf('/') === 0 : false;

        const data = {
            "path": folder.fullItemName,
            "selectedDisks": selectedDisks
        };

        // return this._crudService.get(folder ? `${browseEndPoint}?path=${encodeURIComponent(startsWithSlash ? folder.fullItemName.substring(1) : folder.fullItemName)}` : browseEndPoint).then(res => {
        return this._crudService.post(browseEndPoint, data, false, false, false, true).then(res => {

            let mappedItems = res.data.entities.map(item => {
                item.subType = this.convertFileTypeToSubType(item.fileType);
                return item;
            });
            mappedItems = mappedItems.filter(elem => (elem.fileType === "DIRECTORY" || elem.fileType === "MOUNTPOINT" || elem.fileType === "DISK"));
            mappedItems.forEach(entity => {
                entity.type = this.fileTypesFilter(entity.displayName, (entity.subType & 1) != 0, (entity.subType & 8) != 0);
                entity.modificationTime = this.convertToModifiedDate(entity.modificationTime);
                entity.fileSize ? entity.fileSize = this._utilsService.expressBytes(entity.fileSize) : '';
            });
            folder.addFolders(mappedItems);
        });
    }

    fetchFolderContent(folder, snapUuid, selectedDisks) {
        // reset page number
        let BROWSE_END_POINT = `restore/flr/${snapUuid}`;
        const startsWithSlash = folder ? folder.fullItemName.indexOf('/') === 0 : false;

        const data = {
            "path": folder.fullItemName,
            "selectedDisks": selectedDisks,
            "orderBy": folder.fileTableState.orderBy,
            "pageNumber": folder.fileTableState.page,
            "pageSize": folder.fileTableState.pageSize,
            "filter": folder.searchObject ? folder.searchObject.value : undefined
        };

        return this._crudService.post(BROWSE_END_POINT, data, false, false, false, true).then(res => {
            let mappedItems = res.data.entities.map(item => {
                item.subType = this.convertFileTypeToSubType(item.fileType);
                return item;
            });
            mappedItems.forEach(entity => {
                entity.type = this.fileTypesFilter(entity.displayName, (entity.subType & 1) != 0, (entity.subType & 8) != 0);
                entity.modificationTime = this.convertToModifiedDate(entity.modificationTime);
                entity.fileSize ? entity.fileSize = this._utilsService.expressBytes(entity.fileSize) : '';
            });
            folder.addContent(mappedItems, res.data.metadata);
        });
    }

    convertToModifiedDate(modificationTime) {
        if (!modificationTime) return modificationTime;
        let inSec = modificationTime.toString().length === 10;
        return this.$filter('localizeDate')(modificationTime * (inSec ? 1000 : 1), 'shortSec');
    }

    convertFileTypeToSubType(fileType) {
        switch (fileType) {
            case 'DISK':
                return 32;
            case 'MOUNTPOINT':
                return 18;
            case 'FILE':
                return 1;
            case 'DIRECTORY':
                return 2;
            case 'SYMLINK':
                return 10;
            case 'SYMLINK_DIRECTORY':
                return 10;
        }
    }
}

RecoverFileMountService.$inject = ['$timeout', '$q', '$filter', 'crudService', 'sseService', 'sharedPersistenceService', 'utilsService', 'notificationService', 'storageService'];

module.exports = RecoverFileMountService;



// WEBPACK FOOTER //
// ./src/azurebackup/views/virtualMachines/dialogs/recoverFile/recoverFile.service.js